import {Component, computed, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {
    SelectionPossibilities,
    SelectionPossibility,
    ValueSlotComponent,
    resolveSelectionPossibilityValue,
} from "@app/template-editor/components/value-slot/value-slot.component"
import {ToneMapping, defaultsForToneMapping, parameterKeysForToneMapping, TemplateNode} from "@cm/template-nodes"
import * as changeCase from "change-case"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-tone-mapping-inspector",
    templateUrl: "./tone-mapping-inspector.component.html",
    styleUrl: "./tone-mapping-inspector.component.scss",
    imports: [ValueSlotComponent],
})
export class ToneMappingInspectorComponent extends BaseInspectorComponent<TemplateNode<{toneMapping?: ToneMapping}>, {toneMapping?: ToneMapping}> {
    readonly $toneMappingPossibilites = signal<SelectionPossibilities<ToneMapping>>([
        {value: defaultsForToneMapping("pbr-neutral"), name: "PBR Neutral"},
        {value: defaultsForToneMapping("filmic"), name: "Filmic"},
        {value: defaultsForToneMapping("filmic-advanced"), name: "Filmic (Advanced)"},
        {value: defaultsForToneMapping("contrast"), name: "Contrast"},
        {value: defaultsForToneMapping("corona"), name: "Corona"},
        {value: defaultsForToneMapping("linear"), name: "None (Linear)"},
    ])
    readonly $toneMapping = computed(() => {
        const {toneMapping} = this.$parameters()
        return toneMapping
    })
    readonly $toneMappingProperties = computed(() => {
        const toneMapping = this.$toneMapping()
        if (!toneMapping) return []

        const getLabel = (key: string) => {
            if (key === "highlightCompression") return "Highlight"
            return changeCase.capitalCase(key)
        }

        return parameterKeysForToneMapping(toneMapping.mode).map((key) => ({key, label: getLabel(key)}))
    })
    toneMappingSelected = (selectionPossibility: SelectionPossibility<ToneMapping>) => {
        const toneMapping = this.$toneMapping()
        if (!toneMapping) return false
        const selectionPossibilityValue = resolveSelectionPossibilityValue(selectionPossibility.value)
        return selectionPossibilityValue.mode === toneMapping.mode
    }
}
